import React, { useRef, useState, useEffect } from 'react'
import './header.css'
import { useTranslation } from 'react-i18next'

const Header = ({ loading, titulo, urlImagen, fecha, resumen, ranking, comentarios, contenidoHtml }) => {

  const [t, i18n] = useTranslation("detail_blog");
  const audioRef = useRef(null);
  const volumeRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);
  const [shareOpen, setShareOpen] = useState(false);
  const [volume, setVolume] = useState(1);
  const [isMuted, setIsMuted] = useState(false);
  const [showVolume, setShowVolume] = useState(false);

  const shareRef = useRef(null);
  const triggerRef = useRef(null);

  const shareUrl = window.location.href;
  const shareTitle = titulo;

  const formatDate = (date) => {
    return new Date(date).toLocaleDateString("es-MX", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    }).toUpperCase();
  };

  const numero = (txtresumen) => {
    if (typeof txtresumen === 'string' && txtresumen.trim() !== '') {

      const partes = txtresumen.split("||");

      if (partes.length > 1 && partes[1].trim() !== "") {
        return partes[1].trim();
      }
    }

    const i = Math.floor(Math.random() * 5) + 1;
    return i;
  };

  useEffect(() => {

    const handleClickOutside = (event) => {

      // SHARE
      if (
        shareRef.current &&
        !shareRef.current.contains(event.target) &&
        triggerRef.current &&
        !triggerRef.current.contains(event.target)
      ) {
        setShareOpen(false);
      }

      // VOLUMEN
      if (
        volumeRef.current &&
        !volumeRef.current.contains(event.target)
      ) {
        setShowVolume(false);
      }

    };

    document.addEventListener("click", handleClickOutside);

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };

  }, []);

  const renderStars = (ranking) => {
    const stars = [];

    for (let i = 1; i <= 5; i++) {

      if (ranking >= i) {
        stars.push("/assets/img2026/icon_full_star.svg");
      }
      else if (ranking >= i - 0.5) {
        stars.push("/assets/img2026/icon_half_star.svg");
      }
      else {
        stars.push("/assets/img2026/icon_empty_star.svg");
      }
    }

    return stars;
  };

  const extractAudioUrl = () => {
    if (!contenidoHtml) return null;

    const match = contenidoHtml.match(
      /<source\s+src="([^"]+\.mp3)"/i
    );

    return match ? match[1] : null;
  };

  const audioUrl = extractAudioUrl();

  const formatTime = (time) => {
    if (!time) return "00:00";

    const minutes = Math.floor(time / 60);
    const seconds = Math.floor(time % 60);

    return `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
  };

  const toggleAudio = () => {
    if (!audioRef.current) return;

    if (isPlaying) {
      audioRef.current.pause();
    } else {
      audioRef.current.play();
    }

    setIsPlaying(!isPlaying);
  };

  useEffect(() => {
    const audio = audioRef.current;

    if (!audio) return;

    const updateTime = () => {
      setCurrentTime(audio.currentTime);
    };

    const loadedMetadata = () => {
      setDuration(audio.duration);
    };

    const onEnded = () => {
      setIsPlaying(false);
    };

    audio.addEventListener("timeupdate", updateTime);
    audio.addEventListener("loadedmetadata", loadedMetadata);
    audio.addEventListener("ended", onEnded);

    return () => {
      audio.removeEventListener("timeupdate", updateTime);
      audio.removeEventListener("loadedmetadata", loadedMetadata);
      audio.removeEventListener("ended", onEnded);
    };
  }, [audioUrl]);



  const shareToX = () => {
    console.log("Si entro");
    window.open(
      `https://twitter.com/intent/tweet?url=${encodeURIComponent(shareUrl)}&text=${encodeURIComponent(shareTitle)}`,
      "_blank"
    );
  };

  const shareToFacebook = () => {
    window.open(
      `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`,
      "_blank"
    );
  };

  const shareToLinkedin = () => {
    window.open(
      `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(shareUrl)}`,
      "_blank"
    );
  };

  const shareByEmail = () => {
    window.location.href =
      `mailto:?subject=${encodeURIComponent(shareTitle)}&body=${encodeURIComponent(shareUrl)}`;
  };

  const copyLink = async () => {

    try {
  
      await navigator.clipboard.writeText(shareUrl);
  
      alert(
        i18n.language === "en"
          ? "Link copied successfully"
          : "Liga copiada correctamente"
      );
  
    } catch (err) {
  
      console.error(err);
  
      alert(
        i18n.language === "en"
          ? "Could not copy the link"
          : "No se pudo copiar la liga"
      );
  
    }
  
  };

  const handleVolumeChange = (e) => {
    const newVolume = parseFloat(e.target.value);

    setVolume(newVolume);

    if (audioRef.current) {
      audioRef.current.volume = newVolume;
    }

    setIsMuted(newVolume === 0);
  };

  const toggleMute = () => {
    if (!audioRef.current) return;

    if (isMuted) {
      audioRef.current.muted = false;
      setIsMuted(false);

      // Restaurar volumen si estaba en 0
      if (volume === 0) {
        audioRef.current.volume = 1;
        setVolume(1);
      }
    } else {
      audioRef.current.muted = true;
      setIsMuted(true);
    }
  };

  const progress =
    duration > 0
      ? (currentTime / duration) * 100
      : 0;

  if (loading) {
    return (
      <div class="_ngcontent-ng-c1842723448 _nghost-ng-c4124883879">
        <div className="blog-detail-header-skeleton blog-detail-header">

          <div className="skeleton skeleton-title" />

          <div class="blog-detail-header__meta-row">
            <div className="skeleton skeleton-meta" />
          </div>

          <div className="skeleton skeleton-image blog-detail-hero__image" />

          <div className="skeleton skeleton-audio" />

        </div>
      </div >
    );
  } else {
    return (
      <>
        <div class="_ngcontent-ng-c1842723448 _nghost-ng-c4124883879">
          <header class="blog-detail-header">
            <h1 id="blog-detail-title">{titulo}
            </h1>
            <div class="blog-detail-header__meta-row">
              <p class="blog-detail-header__subtitle">{formatDate(fecha)} · {numero(resumen)} {(t('2026.tiempo'))}
                · {(t('2026.por'))}RICARDO SALINAS</p>
              <div class="_ngcontent-ng-c4124883879 _nghost-ng-c739792243"
                mode="desktop">
                <div aria-label="Calificación y acciones"
                  class="post-actions post-actions--desktop">
                  <div class="post-actions__group post-actions__group--rating">
                    <div class="_ngcontent-ng-c739792243 _nghost-ng-c937772467">
                      <div aria-hidden="true" class="blog-detail-star-rating">
                        {renderStars(ranking).map((star, index) => (
                          <img
                            key={index}
                            alt="Ranking"
                            src={star}
                          />
                        ))}
                      </div>
                    </div>
                    &nbsp;
                    <a
                      href="#coments" class="post-actions__score">{ranking}</a></div>
                  <span
                    aria-hidden="true" class="post-actions__divider"></span>
                  <div class="post-actions__group post-actions__group--comments"><img
                    src="/assets/img2026/icon_comment.svg" alt="Comentarios" aria-hidden="true"
                    class="post-actions__icon" /><a
                      href="#coments" class="post-actions__comments-count">{comentarios}</a>
                  </div>
                  <span aria-hidden="true"
                    class="post-actions__divider"></span>
                  <div class="_ngcontent-ng-c739792243 _nghost-ng-c4200879012">
                    <span class="click-tooltip">
                      <span
                        tabIndex="0"
                        role="button"
                        className="click-tooltip__trigger"
                        aria-expanded={shareOpen}
                        ref={triggerRef}
                        onClick={(e) => {
                          e.stopPropagation();
                          setShareOpen(prev => !prev);
                        }}
                      >
                        <div class="post-actions__group post-actions__group--share">
                          <img src="/assets/img2026/icon_share.svg" alt="Comaprtir en redes" aria-hidden="true" class="post-actions__icon post-actions__icon--share" />
                          <span class="post-actions__share-link">{(t('2026.compartir'))}</span>
                        </div>
                      </span>
                      {shareOpen && (
                        <span
                          className="click-tooltip__panel"
                          ref={shareRef}
                          onClick={(e) => e.stopPropagation()}
                        >
                          <span role="tooltip" class="up-arrow click-tooltip__content">
                            <span class="click-tooltip__actions">
                              <button
                                type="button"
                                aria-label="Compartir en X"
                                className="click-tooltip__action"
                                onClick={shareToX}
                              >
                                <img
                                  src="/assets/img2026/logo_twitter.svg"
                                  alt="Compartir en X"
                                  className="click-tooltip__icon click-tooltip__icon--x"
                                />
                              </button>
                              <button
                                type="button"
                                aria-label="Compartir en Facebook"
                                className="click-tooltip__action"
                                onClick={shareToFacebook}
                              >
                                <img src="/assets/img2026/logo_facebook.svg" alt="Compartir en Facebook" class="click-tooltip__icon click-tooltip__icon--facebook" />
                              </button>
                              <button
                                type="button"
                                aria-label="Compartir por email"
                                className="click-tooltip__action"
                                onClick={shareByEmail}
                              >
                                <img src="/assets/img2026/icon_email.svg" alt="Compartir por correo" aria-hidden="true" class="click-tooltip__icon click-tooltip__icon--email" />
                              </button>
                              <button
                                type="button"
                                aria-label="Compartir en Linkeding"
                                className="click-tooltip__action"
                                onClick={shareToLinkedin}
                              >
                                <img src="/assets/img2026/linkedin.svg" alt="Compartir en LinkedIn" class="click-tooltip__icon click-tooltip__icon--linkedin" />
                              </button>
                              <button
                                type="button"
                                aria-label="Copiar liga"
                                className="click-tooltip__action"
                                onClick={copyLink}
                              >
                                <img src="/assets/img2026/share.svg" alt="Copiar enlace" class="click-tooltip__icon click-tooltip__icon--share" />
                              </button>
                            </span>
                          </span>
                        </span>)}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </header>
          <img src={urlImagen}
            class="blog-detail-hero__image" alt="Rebeldes con causa: nadie vendrá a salvarnos" />

          {audioUrl && (
            <section
              aria-label="Escuchar nota"
              className="blog-detail-hero__audio"
            >

              <audio ref={audioRef}>
                <source src={"https://www.ricardosalinas.com" + audioUrl} type="audio/mpeg" />
              </audio>

              <p className="blog-detail-hero__audio-label">
                {(t('2026.nota-voz'))}
              </p>

              <div
                role="group"
                aria-label="Reproductor de audio"
                className="blog-detail-hero__audio-row"
              >

                <button
                  type="button"
                  aria-label="Reproducir"
                  className="audio-player__play"
                  onClick={toggleAudio}
                >

                  {isPlaying ? (
                    <svg width="10" height="12" viewBox="0 0 10 12">
                      <rect width="3" height="12" fill="#fff" />
                      <rect x="7" width="3" height="12" fill="#fff" />
                    </svg>
                  ) : (
                    <svg width="10" height="12" viewBox="0 0 10 12">
                      <path d="M0 0L10 6L0 12V0Z" fill="#ffffff" />
                    </svg>
                  )}

                </button>

                <span className="audio-player__time">
                  {formatTime(currentTime)} / {formatTime(duration)}
                </span>

                <div
                  aria-hidden="true"
                  className="audio-player__track"
                >
                  <div
                    className="audio-player__progress"
                    style={{
                      width: `${progress}%`
                    }}
                  />
                </div>

                <div className="audio-player__volume">

                  {/* BOTON EXTERNO */}
                  <button
                    type="button"
                    className="audio-player__volume-btn"
                    onClick={() => setShowVolume(prev => !prev)}
                  >

                    <svg width="22" height="22" viewBox="0 0 24 24">
                      <path
                        d="M3 9V15H7L12 20V4L7 9H3Z"
                        fill="currentColor"
                      />

                      {isMuted || volume === 0 ? (
                        <path
                          d="M16 9L21 14M21 9L16 14"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                        />
                      ) : (
                        <>
                          <path
                            d="M16 9C17.5 10.5 17.5 13.5 16 15"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                          />
                          <path
                            d="M19 6C22 9 22 15 19 18"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                          />
                        </>
                      )}
                    </svg>

                  </button>

                  {showVolume && (
                    <div className="audio-player__volume-popup" ref={volumeRef} >

                      {/* BOTON INTERNO */}
                      <button
                        type="button"
                        className="audio-player__volume-btn"
                        onClick={toggleMute}
                      >

                        <svg width="22" height="22" viewBox="0 0 24 24">
                          <path
                            d="M3 9V15H7L12 20V4L7 9H3Z"
                            fill="currentColor"
                          />

                          {isMuted || volume === 0 ? (
                            <path
                              d="M16 9L21 14M21 9L16 14"
                              stroke="currentColor"
                              strokeWidth="2"
                              strokeLinecap="round"
                            />
                          ) : (
                            <>
                              <path
                                d="M16 9C17.5 10.5 17.5 13.5 16 15"
                                stroke="currentColor"
                                strokeWidth="2"
                                strokeLinecap="round"
                              />
                              <path
                                d="M19 6C22 9 22 15 19 18"
                                stroke="currentColor"
                                strokeWidth="2"
                                strokeLinecap="round"
                              />
                            </>
                          )}
                        </svg>

                      </button>

                      <input
                        type="range"
                        min="0"
                        max="1"
                        step="0.01"
                        value={isMuted ? 0 : volume}
                        onChange={handleVolumeChange}
                        className="audio-player__volume-slider"
                      />

                    </div>
                  )}

                </div>

              </div>

            </section>
          )}

        </div>
        <div class="_ngcontent-ng-c1842723448 _nghost-ng-c739792243" mode="mobile" >
          <div aria-label="Calificación y acciones"
            class="post-actions post-actions--mobile">
            <div class="post-actions__group post-actions__group--rating">
              <div class="_ngcontent-ng-c739792243 _nghost-ng-c937772467">
                <div aria-hidden="true" class="blog-detail-star-rating">
                  {renderStars(ranking).map((star, index) => (
                    <img
                      key={index}
                      alt="Ranking"
                      src={star}
                    />
                  ))}
                </div>
              </div><a
                href="#coments" class="post-actions__score">{ranking}</a></div>
            <span aria-hidden="true" class="post-actions__divider"></span>
            <div class="post-actions__group post-actions__group--comments"><img
              src="/assets/img2026/icon_comment.svg" alt="Comentarios" aria-hidden="true"
              class="post-actions__icon" /><a
                href="#coments" class="post-actions__comments-count">{comentarios}</a></div>
            <span aria-hidden="true"
              class="post-actions__divider"></span>

            <div class="_ngcontent-ng-c739792243 _nghost-ng-c4200879012">
              <span class="click-tooltip">
                <span
                  tabIndex="0"
                  role="button"
                  className="click-tooltip__trigger"
                  aria-expanded={shareOpen}
                  ref={triggerRef}
                  onClick={(e) => {
                    e.stopPropagation();
                    setShareOpen(prev => !prev);
                  }}
                >
                  <div class="post-actions__group post-actions__group--share">
                    <img src="/assets/img2026/icon_share.svg" alt="Compartir en redes" aria-hidden="true" class="post-actions__icon post-actions__icon--share" />
                    <span class="post-actions__share-link">{(t('2026.compartir'))}</span>
                  </div>
                </span>
                {shareOpen && (
                  <span
                    className="click-tooltip__panel"
                    onClick={(e) => e.stopPropagation()}
                    ref={shareRef}
                  >
                    <span role="tooltip" class="up-arrow click-tooltip__content">
                      <span class="click-tooltip__actions">
                        <button
                          type="button"
                          aria-label="Compartir en X"
                          className="click-tooltip__action"
                          onClick={shareToX}
                        >
                          <img
                            src="/assets/img2026/logo_twitter.svg"
                            alt="Compartir en X"
                            className="click-tooltip__icon click-tooltip__icon--x"
                          />
                        </button>
                        <button
                          type="button"
                          aria-label="Compartir en Facebook"
                          className="click-tooltip__action"
                          onClick={shareToFacebook}
                        >
                          <img src="/assets/img2026/logo_facebook.svg" alt="Compartir en Facebook" class="click-tooltip__icon click-tooltip__icon--facebook" />
                        </button>
                        <button
                          type="button"
                          aria-label="Compartir por email"
                          className="click-tooltip__action"
                          onClick={shareByEmail}
                        >
                          <img src="/assets/img2026/icon_email.svg" alt="Compartir por email" aria-hidden="true" class="click-tooltip__icon click-tooltip__icon--email" />
                        </button>
                        <button
                          type="button"
                          aria-label="Compartir en Linkeding"
                          className="click-tooltip__action"
                          onClick={shareToLinkedin}
                        >
                          <img src="/assets/img2026/linkedin.svg" alt="Compartir en LinkedIn" class="click-tooltip__icon click-tooltip__icon--linkedin" />
                        </button>
                        <button
                          type="button"
                          aria-label="Copiar liga"
                          className="click-tooltip__action"
                          onClick={copyLink}
                        >
                          <img src="/assets/img2026/share.svg" alt="Copiar enlace" class="click-tooltip__icon click-tooltip__icon--share" />
                        </button>
                      </span>

                    </span>
                  </span>)}
              </span>
            </div>


          </div>
        </div>
      </>

    )
  }
}

export default Header
